import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import '../Pagination.css';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import {
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';

function getTipoActaLabel(tipo) {
  if (tipo === 'R') return 'Regular';
  if (tipo === 'L') return 'Libre';
  if (tipo === 'E') return 'Equivalencia';
  return '';
}

function getTipoActaBadgeClass(tipo) {
  if (tipo === 'R') return 'md-page__badge md-page__badge--success';
  if (tipo === 'L') return 'md-page__badge md-page__badge--danger';
  if (tipo === 'E') return 'md-page__badge md-page__badge--info';
  return 'md-page__badge';
}

export class ConsultarActas extends Component {
  static displayName = ConsultarActas.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      paginationData: [],
      perPage: MD_PAGE_SIZE,
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      searchInput: '',
      searched: false,
      filters: {
        fechaDesde: '',
        fechaHasta: '',
        folio: '',
        libro: '',
        tipoActa: '',
      },
      materia: {
        materiaCarreraCodigo: '',
        descripcion: '',
      },
      showLookupMaterias: false,
      showErrorMessage: false,
      errorMessage: '',
    };
  }

  componentDidMount() {
    constantClass.canAccess('WWActasExamen');
  }

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      filters: {
        ...prev.filters,
        [name]: value,
      },
      showErrorMessage: false,
      errorMessage: '',
    }));
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupMaterias: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupMaterias: false });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupMaterias: false,
      materia: {
        materiaCarreraCodigo: carreraProperties[0],
        descripcion: carreraProperties[1] + ' - ' + carreraProperties[2] + ' - ' + carreraProperties[3],
      },
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleBuscar = async (e) => {
    if (e) e.preventDefault();
    this.setState({ loading: true, searched: true, showErrorMessage: false, errorMessage: '' });
    await this.populateData(0, '');
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  buildRowActions(acta) {
    return [
      {
        key: 'watch',
        label: 'Ver Acta',
        variant: 'outline',
        icon: 'info',
        to: '/aex/watch/' + acta.actaExamenCod,
      },
      {
        key: 'header',
        label: 'Modificar Encabezado',
        variant: 'outline',
        icon: 'pencil',
        to: '/update-eae/' + acta.actaExamenCod,
      },
    ];
  }

  renderTable(actas) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed consultar-actas__table" aria-labelledby="consultar-actas-title">
          <colgroup>
            <col className="consultar-actas__col-folio" />
            <col className="consultar-actas__col-libro" />
            <col className="consultar-actas__col-fecha" />
            <col className="consultar-actas__col-materia" />
            <col className="consultar-actas__col-carrera" />
            <col className="consultar-actas__col-tipo" />
            <col className="consultar-actas__col-actions" />
          </colgroup>
          <thead>
            <tr>
              <MdTableHeaderCell cellType="number" className="consultar-actas__cell consultar-actas__cell--folio">Folio</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="consultar-actas__cell consultar-actas__cell--libro">Libro</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date" className="consultar-actas__cell consultar-actas__cell--fecha">Fecha Examen</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Materia</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Carrera</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="consultar-actas__cell consultar-actas__cell--tipo md-page__table__badge-cell">Tipo de Acta</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {actas.map((acta) => (
              <tr key={acta.actaExamenCod}>
                <MdTableCell cellType="number" className="consultar-actas__cell consultar-actas__cell--folio">{acta.actaExamenFolio}</MdTableCell>
                <MdTableCell cellType="text" className="consultar-actas__cell consultar-actas__cell--libro">{acta.actaExamenLibro}</MdTableCell>
                <MdTableCell cellType="date" className="consultar-actas__cell consultar-actas__cell--fecha">{constantClass.formatDisplayDate(acta.mesaExamenFechaExamen)}</MdTableCell>
                <MdTableCell cellType="text">{acta.materiaNombre}</MdTableCell>
                <MdTableCell cellType="text">{acta.carreraNombre}</MdTableCell>
                <MdTableCell cellType="text" className="consultar-actas__cell consultar-actas__cell--tipo md-page__table__badge-cell">
                  <span className={getTipoActaBadgeClass(acta.actaExamenTipo)}>
                    {getTipoActaLabel(acta.actaExamenTipo)}
                  </span>
                </MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions items={this.buildRowActions(acta)} />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { loading, searched, paginationData, pageCount, offset, perPage } = this.state;
    const hasResults = !loading && searched && paginationData.length > 0;
    const noResults = !loading && searched && paginationData.length === 0;

    return (
      <div className="md-page md-form-page consultar-actas">
        <h1 id="consultar-actas-title" className="md-page__title">Consulta de Actas de Exámenes</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
        </div>

        <div className="md-form-page__card">
          <form className="md-form-page__form md-form-page__form--filters" onSubmit={this.handleBuscar} noValidate>
            <div className="md-form-page__filters-grid">
              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="consultar-fecha-desde">
                  Fecha desde
                </label>
                <input
                  id="consultar-fecha-desde"
                  className="md-form-page__input"
                  type="date"
                  name="fechaDesde"
                  value={this.state.filters.fechaDesde}
                  disabled={this.state.loading}
                  onChange={this.handleFilterChange}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="consultar-fecha-hasta">
                  Fecha hasta
                </label>
                <input
                  id="consultar-fecha-hasta"
                  className="md-form-page__input"
                  type="date"
                  name="fechaHasta"
                  value={this.state.filters.fechaHasta}
                  disabled={this.state.loading}
                  onChange={this.handleFilterChange}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="consultar-folio">
                  Folio
                </label>
                <input
                  id="consultar-folio"
                  className="md-form-page__input"
                  type="text"
                  name="folio"
                  value={this.state.filters.folio}
                  disabled={this.state.loading}
                  onChange={this.handleFilterChange}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="consultar-libro">
                  Libro
                </label>
                <input
                  id="consultar-libro"
                  className="md-form-page__input"
                  type="text"
                  name="libro"
                  value={this.state.filters.libro}
                  disabled={this.state.loading}
                  onChange={this.handleFilterChange}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="consultar-tipo-acta">
                  Tipo acta
                </label>
                <select
                  id="consultar-tipo-acta"
                  className="md-form-page__input"
                  name="tipoActa"
                  value={this.state.filters.tipoActa}
                  disabled={this.state.loading}
                  onChange={this.handleFilterChange}
                >
                  <option value="">Todos</option>
                  <option value="L">Libre</option>
                  <option value="R">Regular</option>
                  <option value="E">Equivalencia</option>
                </select>
              </div>

              <div className="md-form-page__field md-form-page__field--materia-compact">
                <span className="md-form-page__label">Materia</span>
                <div className="md-form-page__materia-controls">
                  <button
                    type="button"
                    className="md-form-page__pick-btn"
                    onClick={this.handleShowCarreraLookup}
                    disabled={this.state.loading}
                  >
                    Seleccione la Materia
                  </button>
                  <input
                    className="md-form-page__input"
                    type="text"
                    readOnly
                    disabled
                    value={this.state.materia.descripcion}
                    placeholder="Todas las materias"
                    aria-label="Materia seleccionada"
                  />
                </div>
                {this.state.showLookupMaterias ? (
                  <LookupMaterias
                    selectItem={this.handleSelectCarreraItem}
                    hideLookup={this.handleHideLookup}
                  />
                ) : null}
              </div>
            </div>

            <div className="md-form-page__actions md-form-page__actions--filters">
              <button
                type="submit"
                className="md-form-page__btn md-form-page__btn--primary"
                disabled={this.state.loading}
              >
                Buscar
              </button>
            </div>
          </form>
        </div>

        {loading ? (
          <p className="md-page__loading"><em>Cargando resultados...</em></p>
        ) : null}

        {noResults ? (
          <p className="md-page__empty"><em>No hay resultados</em></p>
        ) : null}

        {hasResults ? this.renderTable(paginationData) : null}

        {hasResults && pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(offset / perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}
      </div>
    );
  }

  async populateData(page = 0, search = '') {
    const { filters, materia } = this.state;
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/aex/consultar',
      page,
      search,
      perPage: this.state.perPage,
      extraParams: {
        fechaDesde: filters.fechaDesde,
        fechaHasta: filters.fechaHasta,
        folio: filters.folio,
        libro: filters.libro,
        materiaCarreraCod: materia?.materiaCarreraCodigo,
        tipoActa: filters.tipoActa,
      },
    });
  }
}
